import { __rest } from "tslib";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Fragment } from 'react';
import { OrderSummaryLineItem } from './OrderSummaryLineItem';
export const OrderSummaryItems = ({ items, locale, }) => (_jsx(Box, { flexDirection: "column", flexGrow: 1, children: items.map((_a, index) => {
        var { render } = _a, item = __rest(_a, ["render"]);
        const key = `order-summary-item-${item.id}`;
        if (typeof render === 'function') {
            return _jsx(Fragment, { children: render(item) }, key);
        }
        return _createElement(OrderSummaryLineItem, Object.assign({}, item, { key: key, locale: locale }));
    }) }));
//# sourceMappingURL=OrderSummaryItems.js.map